import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, QueryParameterState, addQueryParam, changeQueryParams } from 'src/api';
import { RouterState } from 'connected-react-router';
import { Icon } from '../../Images';

import './NewButtons.scss';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './NewButtons.messages';
import { userIsInternal, userIsExternal } from '../../Admin/utils';
import { Link } from 'react-router-dom';
import { ModalContainer } from 'src/app/Container/Modal/Modal';
import ConfigurationNewFolder from './ConfigurationNewFolder';
import { requestAPIActions, RequestApiHttpPayload } from 'loopback-react-request';
import { createApiUrl, appSettings } from 'src/config';

export interface NewButtonsState {
  isCreatingFolder: boolean;
}

export interface NewButtonsProps {
  dispatch: any;
  user: GlobalPrivateState['user'];
  userData: GlobalPrivateState['userData'];
  groups: GlobalPrivateState['groups'];
  folderId?: string;
  authenticator: GlobalPrivateState['authenticator'];
  params: QueryParameterState['params'];
}

export class NewButtonsPartial extends React.Component<NewButtonsProps, NewButtonsState> {

  constructor(props: NewButtonsProps) {
    super(props);
    this.state = {
      isCreatingFolder: false
    };
  }

  public render() {
    const { userData, user, groups, folderId } = this.props;
    const { list, tab } = this.props.params;
    const currentGroup = folderId && groups && groups.result && Array.isArray(groups.result) && groups.result.find(g => g.id === folderId);
    const isExternal = userIsExternal(user.result);
    const isNested = currentGroup ? true : false;
    const canCreateFolder = !isExternal && (!currentGroup || (currentGroup && !currentGroup.parentId)) && (tab !== 'others' && tab !== 'archived');

    // Cant create configuration if URL path is exactly '/folders'
    const isFolderPath = window.location.pathname === '/folders';

    return (
			<>
        <div className="newbuttons-actions">
          {canCreateFolder && (
            <div className="btn btn-text" onClick={() => {this.setState({isCreatingFolder: true})}}>
              <span>+ <FormattedMessage {...MESSAGES.newButtonsNewFolder} /></span>
            </div>
          )}
          {!isFolderPath && (
            <Link className="btn btn-secondary text-center" to={`/configuration/new${folderId ? '?folderId='+folderId : ''}`}>
              <span><FormattedMessage {...MESSAGES.newButtonsNewConfiguration} /></span>
            </Link>
          )}
        </div>

        {this.state.isCreatingFolder && (
          <ConfigurationNewFolder
            parentId={folderId}
            isNested={isNested}
            drilledClose={() => {
              this.setState({isCreatingFolder: false});
            }}
            drilledConfirm={async (folderName) => {
              this.setState({isCreatingFolder: false});
            }}
          />
        )}
      </>
    );
  }
}

export const NewButtons = connect((state: GlobalPrivateState) => ({
  user: state.user,
  userData: state.userData,
  groups: state.groups,
  authenticator: state.authenticator,
  params: state.queryState.params,
}))(NewButtonsPartial);

export default NewButtons;
